import React from "react";

class SwitchTabs extends React.PureComponent {
  render() {
    const { tabs, selectedTabKey, handleChange } = this.props;

    return (
      <div className="border rounded divide-x inline-flex overflow-hidden border-gray-400">
        {tabs.map((tab) => (
          <button
            type="button"
            className={`focus:outline-none px-4 text-sm font-semibold leading-7 ${
              selectedTabKey === tab.value
                ? "bg-blue-400 text-white"
                : "bg-white text-gray-700 hover:bg-gray-200"
            }`}
            onClick={() => handleChange(tab.value)}
            key={tab.value}
          >
            {tab.label}
          </button>
        ))}
      </div>
    );
  }
}

export default SwitchTabs;
